import React from 'react';
import {FaIcon} from "../FaIcon";
import {EditElementModal} from "../EditElementModal";
import {EditBudgetForm} from "./EditBudgetForm";

export class EditBudgetModal extends EditElementModal {
    renderModalForm() {
        return <EditBudgetForm closeModal={this.toggle}
                               onModified={this.handleFormSubmitted}
                               businessUnitId={this.props.businessUnitId}
                               campaignsConfigurationId={this.props.campaignsConfigurationId}
                               campaignId={this.props.campaignId}
                               adgroupId={this.props.adgroupId}
                               budget={this.props.value}
                               budgetPeriodType={this.props.periodType}
                               budgetFromDate={this.props.fromDate}
                               budgetToDate={this.props.toDate}
                               budgetPartialGoals={this.props.budgetPartialGoals}
                               clientName={this.props.clientName}
                               businessUnitName={this.props.businessUnitName}/>
    }

    renderButton() {
        return <button className="edit-button" onClick={this.toggle}><FaIcon iconName={"pencil-alt"}/></button>;
    }

    renderModalHeaderText() {
        return "Editar Presupuesto";
    }
}
